var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33.05a1.333 1.333 0 10.7 2.573A1.333 1.333 0 007.33.05zm4.907 2.648a1.333 1.333 0 10.79-2.546 1.333 1.333 0 00-.79 2.546zM6.982 19.847a1.333 1.333 0 10.79-2.547 1.333 1.333 0 00-.79 2.547zM17.29 4.603A1.335 1.335 0 1115.4 2.715a1.335 1.335 0 011.889 1.888zM2.719 17.288a1.336 1.336 0 101.889-1.889 1.336 1.336 0 00-1.889 1.889zm16.293-8.325a1.333 1.333 0 11-.7-2.572 1.333 1.333 0 01.7 2.572zM.05 12.67a1.333 1.333 0 102.572-.7 1.333 1.333 0 00-2.572.7zm18.265.83a1.333 1.333 0 11.7-2.573 1.333 1.333 0 01-.7 2.574zM.054 7.222a1.333 1.333 0 102.573.699A1.333 1.333 0 00.054 7.22zm15.352 10.065a1.336 1.336 0 111.89-1.89 1.336 1.336 0 01-1.89 1.89zM2.726 2.714a1.336 1.336 0 101.889 1.89 1.336 1.336 0 00-1.89-1.89zm8.31 16.3a1.333 1.333 0 112.573-.7 1.333 1.333 0 01-2.572.7z",
    fill: "currentcolor"
  })));
}

export default SvgUnion;